import { LocalStorageUtilsBuyer } from '../buyer/_utils/localstoragebuyer';
import { LocalStorageKeys } from '../_models/localStorageKeys';
import { User } from "../_models/user";

declare const cc: boolean;
declare const CryptoJS: any;
declare const isEmpty: any;

export class LocalStorageUtils {
    private localStorageKeys: LocalStorageKeys
    private localStorageUtilsBuyer: LocalStorageUtilsBuyer

    constructor() {
        this.localStorageUtilsBuyer = new LocalStorageUtilsBuyer();
        this.localStorageKeys = new LocalStorageKeys();
    }

    public deleteHasUserAlreadyAccessedByDayData(userCompanyId: number) {
        localStorage.removeItem(this.localStorageKeys.getAlreadyAccessed(userCompanyId));
    }

    private getHasUserAlreadyAccessedByDayData(userCompanyId: number): { expirationDate: Date } | null {
        let lsAlreadyAccessed = localStorage.getItem(this.localStorageKeys.getAlreadyAccessed(userCompanyId));

        if (isEmpty(lsAlreadyAccessed))
            return null;

        if (!cc) {
            return JSON.parse(lsAlreadyAccessed)
        }

        let decrypted = CryptoJS.AES.decrypt(lsAlreadyAccessed, this.localStorageKeys.cryptKey);
        let result = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));

        return result;
    }

    public getHasUserAlreadyAccessedByDay(user: User): boolean {
        let hasUserAlreadyAccessed = this.getHasUserAlreadyAccessedByDayData(user.user_company_id);

        if (hasUserAlreadyAccessed == null)
            return false;

        if (new Date(hasUserAlreadyAccessed.expirationDate) < new Date()) {
            this.deleteHasUserAlreadyAccessedByDayData(user.user_company_id);
            return false;
        }

        return true;
    }

    public limparDadosImpressao() {
        localStorage.removeItem(this.localStorageKeys.ilog);
    }

    public limparDadosUsuario() {
        this.localStorageUtilsBuyer.limparDadosLocaisDadosCentralSemaforo();

        localStorage.removeItem(this.localStorageKeys.ulog);
        this.limparDadosImpressao();
    }

    public obterDadosImpressao(): any {
        try {
            let ilog = localStorage.getItem(this.localStorageKeys.ilog);

            if (isEmpty(ilog))
                return JSON.parse(ilog);

            let decrypted = CryptoJS.AES.decrypt(ilog, this.localStorageKeys.cryptKey);

            if (cc)
                return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));

            return JSON.parse(ilog);
        } catch (e) {
            return [];
        }
    }

    public obterUsuario(): User {
        try {
            let ulog = localStorage.getItem(this.localStorageKeys.ulog);

            if (isEmpty(ulog))
                return JSON.parse(ulog);

            let decrypted = CryptoJS.AES.decrypt(ulog, this.localStorageKeys.cryptKey);

            if (cc)
                return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));

            return JSON.parse(ulog);
        } catch (e) {
            this.limparDadosUsuario();
        }
    }

    public salvarDadosImpressao(data: any)
    {
        let ilog = JSON.stringify(data);
        let encrypted = CryptoJS.AES.encrypt(ilog, this.localStorageKeys.cryptKey);

        if (cc)
            localStorage.setItem(this.localStorageKeys.ilog, encrypted.toString());
        else
            localStorage.setItem(this.localStorageKeys.ilog, ilog);
    }

    public salvarDadosUsuario(user) {
        let ulog = JSON.stringify(user);
        let encrypted = CryptoJS.AES.encrypt(ulog, this.localStorageKeys.cryptKey);

        if (cc)
            localStorage.setItem(this.localStorageKeys.ulog, encrypted.toString());
        else
            localStorage.setItem(this.localStorageKeys.ulog, ulog);
    }

    public saveHasUserAlreadyAccessedByDayData(user: User): void {
        let expirationDate = new Date()
        expirationDate.setHours(24, 0, 0, 0); // Seta a data para a meia noite do próximo dia

        let hasUserAlreadyAccessedByDayData: { expirationDate: Date } = { expirationDate }

        let alreadyAccessed = JSON.stringify(hasUserAlreadyAccessedByDayData);
        let encrypted = CryptoJS.AES.encrypt(alreadyAccessed, this.localStorageKeys.cryptKey);

        if (!cc)
            localStorage.setItem(this.localStorageKeys.getAlreadyAccessed(user.user_company_id), alreadyAccessed);
        else
            localStorage.setItem(this.localStorageKeys.getAlreadyAccessed(user.user_company_id), encrypted.toString());
    }
}

